import { CommonData } from '../common_schema'

export const errorData: CommonData[] = [
  {
    name: 'Abnormal stores(summary for all type)',
    mean: 'abnormal_store:total.values.mean',
    std: 'abnormal_store:total.values.std',
    location: 'Dev Tier TiDB in One Screen --> Abnormal stores'
  },
  {
    name: 'Region health(summary for all, except learner-peer-region-count)',
    mean: 'unhealthy_regions:total.values.mean',
    std: 'unhealthy_regions:total.values.std',
    location: 'PD --> Region health'
  },
  {
    name: 'TiKV Errors(summary)',
    mean: 'TiKV_Error:total.values.mean',
    std: 'TiKV_Error:total.values.std',
    location: 'TiKV-Details --> Errors'
  },
  {
    name: 'Raft message for vote(avg)',
    mean: 'raft_message_for_vote:total.values.mean',
    std: 'raft_message_for_vote:total.values.std',
    location: 'TiKV-Details --> Raft message --> vote'
  },
  {
    name: 'Worker pending tasks(all)',
    mean: 'working_pending_tasks:total.values.mean',
    std: 'working_pending_tasks:total.values.std',
    location: 'TiKV-Details  --> Tasks --> Worker pending tasks'
  },
  {
    name: 'PD heartbeats(pending, maximum in the TiKVs)',
    mean: 'pd_pending_heartbeat_max:total.values.mean',
    std: 'pd_pending_heartbeat_max:total.values.std',
    location: 'TiKV-Details --> PD --> PD heartbeats(pending)'
  }
]
